class ProtectUnload {
  static on() {
    console.log("ProtectUnload on");
    window.addEventListener("beforeunload", this.callbackFn);
  }
  static off() {
    console.log("ProtectUnload off");
    window.removeEventListener("beforeunload", this.callbackFn);
  }
  static callbackFn(event) {
    event.preventDefault();
    event.returnValue = "";
  }
}

module.exports = ProtectUnload;
